import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { Folder } from 'Interfaces/Folder';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((folderIds: Folder['id'][]) =>
    $actions.folder.deleteFolders(dispatch, { folderIds }),
  );
};
